import React from 'react';

import Link from 'common/Link';
import styles from 'css-module/components/www/_PricingV4.module.scss';

export default function PricingV4CaseStudies() {
  return (
    <Link to="/case-studies" className={styles.pricingV4CaseStudies}>
      Learn more about how other teams use&nbsp;Canny&nbsp;&rarr;
    </Link>
  );
}
